import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function UpsellView 
 * @param {React.Component} icon Pass an icon as a React component into the component.
 * @param {STRING} text Pass the text as a string into the component.
 * @param {STRING} textClass Pass additional CSS class name for the text.
 * @returns {React.Component}
 * @example
 * <UpsellView icon={<SVGAsset id="SomeAsset"} text="Some text" textClass="some-class" />
 */
export default function UpsellView(props) {
  const icon = props.icon ?? <SVGAsset id="LightBulbIcon" className="light-bulb-icon" />;
  const biller = props.biller ?? {};
  const subtextDataPoint = props.dataPoint ? {"data-point" : props.dataPoint + "_Subtext_" + biller.id } : {};
  const chevronDataPoint = props.dataPoint ? {"data-point" : props.dataPoint + "_Chevron_" + biller.id } : {};
  
  return (
    <div className="upsell-view flex-container flex-horizontal align-center row-alert-content flex-width clickable" onClick={props.onClick}>
      <div className="set-width flex-container all-center icon-container">
        {icon}
      </div>

      <div className="flex-width alert-info-container">
        <span className={"sub-text link " + props.textClass} { ...subtextDataPoint }>{props.text}</span>
      </div>
      <div className="set-width flex-container all-center link">
        <SVGAsset id="RightChevronIcon" className="right-chevron-icon"  {...chevronDataPoint}/>
      </div>
    </div>
  );
}
